<template>
  <div class="w-full">
    <div
      v-if="props.variant === 'frameworks'"
      class="w-full py-6 bg-[#F0E5FF] dark:bg-[#521B9A66] rounded-xl mb-6 text-center"
    >
      <div class="max-w-max mx-auto">
        <p class="mb-5">We are the official partner of top used framework</p>
        <div class="flex gap-6 justify-center items-center">
          <NuxtLink
            to="https://partners.laravel.com/partners/webreinvent"
            target="_blank"
            class="flex items-center gap-2"
          >
            <span class="size-9 grid place-content-center bg-white rounded-md">
              <NuxtImg
                src="/images/laravel-menu-icon.webp"
                width="28"
                height="29"
                format="webp"
                alt="laravel Icon"
              />
            </span>
            Laravel
          </NuxtLink>
          <NuxtLink
            to="https://nuxt.com/support/agencies/webreinvent"
            target="_blank"
            class="flex items-center gap-2"
          >
            <span class="size-9 grid place-content-center bg-white rounded-md">
              <NuxtImg
                src="/images/nuxt-menu-icon.webp"
                width="29"
                height="30"
                format="webp"
                alt="nuxt Icon"
              />
            </span>
            Nuxt.JS
          </NuxtLink>
          <NuxtLink
            to="https://cn.vuejs.org/partners/webreinvent"
            target="_blank"
            class="flex items-center gap-2"
          >
            <span class="size-9 grid place-content-center bg-white rounded-md">
              <NuxtImg
                src="/images/vue-menu-icon.webp"
                width="28"
                height="28"
                format="webp"
                alt="vue Icon"
              />
            </span>
            Vue.JS
          </NuxtLink>
        </div>
      </div>
    </div>
    <div
      v-if="props.variant === 'cms'"
      class="w-full py-6 bg-[#F0E5FF] dark:bg-[#521B9A66] rounded-xl mb-6 text-center"
    >
      <div class="max-w-max mx-auto">
        <p class="mb-5">Our flagship in-house product</p>
        <div class="flex gap-6 justify-center items-center">
          <NuxtLink
            to="https://vaah.dev/cms"
            target="_blank"
            class="flex items-center gap-2"
          >
            <WrCmsIcon />
            VaahCMS
          </NuxtLink>
          <NuxtLink
            to="https://vaah.dev/store"
            target="_blank"
            class="flex items-center gap-2"
          >
            <WrStoreIcon />
            VaahStore
          </NuxtLink>
          <NuxtLink
            to="https://vaah.dev/ai"
            target="_blank"
            class="flex items-center gap-2"
          >
            <WrAiIcon />
            VaahAI
          </NuxtLink>
        </div>
      </div>
    </div>
    <div class="flex flex-col min-h-max">
      <div
        class="flex gap-4 border-b border-[#F0E5FF] dark:border-[#FFFFFF1A] min-h-max h-[calc(100%-4rem)] overflow-y-auto"
      >
        <div
          v-for="group in items"
          :key="group.label"
          class="first:w-full first:grow first:max-w-max max-w-[220px] mb-6"
        >
          <h3
            v-if="group.label"
            class="mb-3 dark:bg-[#9857C84D] rounded-full px-5 py-2.5 text-base"
          >
            {{ group.label }}
          </h3>
          <div class="flex flex-wrap" :class="group.appendClass">
            <NuxtLink
              v-for="item in group.items"
              :key="item.item"
              class="text-black/80 dark:text-white/80 flex gap-2 items-center py-2 px-4 mb-2 w-1/2 dark:hover:bg-[#FFFFFF0D] hover:bg-[#F0E5FF] rounded-full transition-colors duration-200 cursor-pointer"
              :to="item.link"
              @click="handleClose"
            >
              <!-- Icon or fallback -->
              <span
                v-if="item.iconPosition !== 'bg-[position:0px_0px]'"
                class="mr-2 size-6"
                :class="[
                  item.iconPosition,
                  $colorMode.preference== 'dark'
                    ? 'bg-[url(/images/menu-icons.webp)]'
                    : 'bg-[url(/images/menu-icons-light.webp)]',
                ]"
              />

              <!-- Fallback icon (first letter) -->
              <span
                v-else
                class="mr-2 size-6 flex items-center justify-center rounded-full text-white text-xs font-semibold"
                :style="{ backgroundColor: getColorForLabel(item.label) }"
              >
                {{ item.label.charAt(0).toUpperCase() }}
              </span>

              <span>{{ item.label }}</span>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-center items-center pt-5">
      <Button asChild v-slot="slotProps" unstyled>
        <RouterLink
          to="/services"
          class="bg-[#AE45AA] dark:bg-[#521B9A] !text-white !font-normal px-20 py-2 rounded-full"
        >
          All Services ></RouterLink
        >
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import WrAiIcon from "../atoms/icons/WrAiIcon.vue";
import WrCmsIcon from "../atoms/icons/WrCmsIcon.vue";
import WrDesign from "../atoms/icons/WrDesign.vue";
import WrStoreIcon from "../atoms/icons/WrStoreIcon.vue";
import { useGlobalStore } from "~/stores/globalStore";
const globalStore = useGlobalStore();

const colors = [
  "#A44AE1",
  "#4AE1A4",
  "#E14A4A",
  "#4A6BE1",
  "#E1A44A",
  "#FF7F50",
  "#9370DB",
  "#20B2AA",
  "#FF69B4",
  "#6495ED",
];

function getColorForLabel(label) {
  // Pick a color based on the label hash
  const index = label.charCodeAt(0) % colors.length;
  return colors[index];
}

type Item = {
  label?: string;
  icon?: any;
  item?: string;
  iconPosition?: string;
};

type ItemsGroup = {
  label?: string;
  items?: Item[];
  appendClass?: string;
  showExtraContent?: boolean;
};

type Variant = "default" | "frameworks" | "cms";

type Props = {
  items: ItemsGroup[];
  link?: string;
  variant?: Variant;
};
const emit = defineEmits(["close"]);

const handleClose = () => {
  emit("close");
  console.log("emit triggered");
};

const props = withDefaults(defineProps<Props>(), {
  variant: "default",
  items: () => [
    {
      label: "Backend",
      items: [
        { title: "Item 1", icon: WrDesign, item: "item1" },
        { title: "Item 2", icon: WrDesign, item: "item2" },
        { title: "Item 2", icon: WrDesign, item: "item2" },
        { title: "Item 2", icon: WrDesign, item: "item2" },
        { title: "Item 2", icon: WrDesign, item: "item2" },
        { title: "Item 2", icon: WrDesign, item: "item2" },
        { title: "Item 2", icon: WrDesign, item: "item2" },
        { title: "Item 2", icon: WrDesign, item: "item2" },
      ],
    },
  ],
});
</script>
